import type { AppSwitcherItemProps } from '../types/interfaces'

interface AppSwitcherItemOptions {
  props: AppSwitcherItemProps
  onClick: () => void
}

interface AppSwitcherItemReturn {
  handleClick: () => void
}

export const useAppSwitcherItem = ({ props, onClick }: AppSwitcherItemOptions): AppSwitcherItemReturn => {
  const handleClick = (): void => {
    if (props.selected || props.disabled) return
    onClick()
  }

  return {
    handleClick,
  }
}
